<template>
  <BLayoutExpansionTable
    :value="list"
    :readonly="readonly"
    :skeleton="skeleton"
    :validate="validate"
    :pagination="pagination"
    type-table="publication-munmeh"

    :title="title"
    :creatable="creatable"

    v-on="$listeners || {}"
  />
</template>

<script>
import BLayoutExpansionTable from '@/components/layouts/BLayoutExpansionTable.vue'


export default {
  name: 'PublicationMunMehExpansionTable',
  components: {
    BLayoutExpansionTable,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    title: String,
    creatable: Boolean,
    readonly: Boolean,
    skeleton: Boolean,
    pagination: Object,
    validate: [String, Object],
  },
}
</script>
